// Meta-economy math: elmas rewards for match outcomes + the optional rewarded-ad top-up, plus guest
// name generation. This is UI/meta-layer logic and lives OUTSIDE src/game so the deterministic engine
// never depends on it (makeGuestName uses Math.random). Amounts follow docs/META-ECONOMY.md section 2.

/** Base elmas for finishing a match. Winning pays; losing pays nothing (this kills loss-farming). */
export const MATCH_WIN_ELMAS = 10;
export const MATCH_LOSS_ELMAS = 0;

/** The +N a loser can earn by opting into the results-screen rewarded ad (a small consolation). */
export const LOSS_AD_ELMAS = 5;

/** Base elmas granted just for finishing the match (before any rewarded-ad bonus). */
export function matchElmas(win: boolean): number {
  return win ? MATCH_WIN_ELMAS : MATCH_LOSS_ELMAS;
}

/** Extra elmas granted only when the results-screen rewarded ad plays to completion.
 *  Win: another +10 so the total is 2x. Loss: a +5 consolation on top of the base 0. */
export function matchAdBonus(win: boolean): number {
  return win ? MATCH_WIN_ELMAS : LOSS_AD_ELMAS;
}

// --- guest identity: assigned once and persisted in Profile, shown until a CrazyGames login overrides it ---
/** A CrazyGames-style guest name like "Guest1023543" (assigned once). Uses Math.random (meta layer only). */
export function makeGuestName(): string {
  return `Guest${1000000 + Math.floor(Math.random() * 8999999)}`;
}
